import WarehouseNotRequiringContact from "@/GeneratedFixtures/WarehouseNotRequiringContact.json";

export function bookShipmentIsWarehouseNotRequiringContact(
  brand: string | undefined,
): boolean {
  if (!brand) return false;
  return WarehouseNotRequiringContact.includes(brand);
}
